import { render, staticRenderFns } from "./ConsentView.vue?vue&type=template&id=5ab6a204&"
import script from "./ConsentView.vue?vue&type=script&lang=js&"
export * from "./ConsentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../WebApp_Client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../WebApp_Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
